import { Controller } from "@hotwired/stimulus"

// シンプルなタブ切替コントローラ。
// data-tabs-target="tab" の要素クリックで data-tab-key を取り、 対応する panel の表示を切り替える。
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show(this.tabTargets[0]?.dataset.tabKey)
  }

  select(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.tabKey)
  }

  show(key) {
    if (!key) return
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tabKey === key
      if (active) {
        tab.classList.add("bg-indigo-600", "text-white")
        tab.classList.remove("bg-gray-100", "text-gray-700", "hover:bg-gray-200")
      } else {
        tab.classList.add("bg-gray-100", "text-gray-700", "hover:bg-gray-200")
        tab.classList.remove("bg-indigo-600", "text-white")
      }
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabKey !== key)
    })
  }
}
